export function monthIndexToTranslationKey(monthIndex: number): string {
  const keys = [
    "global.january", "global.february", "global.march", "global.april", "global.may",
    "global.june", "global.july", "global.august", "global.september", "global.october", "global.november", "global.december"
  ];
  return keys[monthIndex];
}